import * as board from './types';

const getters = {
  [board.ARTICLE]: state => state.article,
  [board.ARTICLE_LIST]: state => state.articles,
  [board.ARTICLE_COUNT]: state => state.articles.totalElements,
  [board.ARTICLE_LIST2]: state => state.articles2,
  [board.ARTICLE_COUNT2]: state => state.articles2.totalElements,
  [board.ARTICLE_LIST3]: state => state.articles3,
  [board.ARTICLE_COUNT3]: state => state.articles3.totalElements,
};

export default getters;
